import Model, { attr } from '@ember-data/model';

import type { TemplateObjectType as ObjectType } from 'webapp/enums/enums';

import type { Creator, TemplateMetricKey } from 'webapp/models-custom/template';

export default class TemplateRecord extends Model {
	@attr('string') title!: string;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	categories!: number[];
	@attr('object', {
		defaultValue() {
			return {};
		},
	})
	createdBy!: Creator;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	boardIds!: number[];
	@attr('string') description!: string;
	@attr('number') objectId!: number;
	@attr('number') objectType!: ObjectType;
	@attr('string') token!: string; // preview token
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	metricKeys!: TemplateMetricKey[]; // keeping this bcos website still uses it. reading only the "name"
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	images!: string[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	sources!: number[];
	@attr('number') usedCount!: number;
	@attr('string') keywords!: string;
	@attr('boolean') isPublic!: boolean;
	@attr('boolean') hasMergedDatasetMetrics!: boolean;
}
